export default __webpack_public_path__ + "static/lactose-free-622a247bd55337e335f04353d5873eb1.svg";